// Design-system buttons pointing at an id on the same page — the case studies
// hero CTA (issue #202) plus the hero fallbacks that jump to #main /
// #cs-detail-article. A plain anchor teleports; these scroll.
//
// Uses the browser's own smooth scrolling rather than a JS tween. A tween has
// to set scroll position every frame, and on these pages that re-runs every
// GSAP ScrollTrigger and the logo marquee on each step, which showed up as
// stutter. Native smooth scrolling is driven by the browser instead, and it
// matches how case-study-detail-toc.js already scrolls its ToC links.
const SELECTOR = 'a.btn[href^="#"]';

const prefersReducedMotion = () =>
	window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

// Only offset when the header actually overlays the scrolled page. On the hero
// pages it is absolute and scrolls away with the hero, so the target should
// land flush at the top — subtracting a header height there would leave a gap.
const headerOffset = () => {
	const header = document.querySelector('.site-header');

	if (!header) {
		return 0;
	}

	const { position } = window.getComputedStyle(header);

	if (position !== 'fixed' && position !== 'sticky') {
		return 0;
	}

	return header.getBoundingClientRect().height;
};

const bindLink = (link) => {
	link.addEventListener('click', (event) => {
		const id = (link.getAttribute('href') || '').slice(1);

		// A bare "#" or an anchor whose target isn't on this page: leave the
		// browser's own behaviour alone rather than swallowing the click.
		if (!id) {
			return;
		}

		const target = document.getElementById(id);

		if (!target) {
			return;
		}

		event.preventDefault();

		// replaceState, not location.hash — assigning the hash makes the browser
		// jump instantly, which is the thing we're replacing. It also keeps the
		// back button from filling up with one entry per in-page scroll.
		window.history.replaceState(null, '', `#${id}`);

		const top = target.getBoundingClientRect().top + window.scrollY - headerOffset();

		window.scrollTo({
			top,
			behavior: prefersReducedMotion() ? 'auto' : 'smooth',
		});
	});
};

export function initAnchorScroll() {
	document.querySelectorAll(SELECTOR).forEach(bindLink);
}
